import { Chat, PinnedChat, ThreadChat } from '@src/api/shared/community/chatApiClient';
import IconPin from '@src/assets/images/common/icon/channel/chat-menu-pin.svg';
import ChatAvatar from '@src/features/shared/community/components/chat/chatList/ChatAvatar';
import ChatDisplayName from '@src/features/shared/community/components/chat/chatList/ChatDisplayName';
import { isThread } from '@src/utils/chat';
import dayjs from 'dayjs';
import React from 'react';

type ChatItemHeaderProps = {
  chat: Chat | PinnedChat | ThreadChat;
  pinnedChat?: PinnedChat;
  isLoggedIn?: boolean;
};

export const TOOLTIP_DISPLAY_TIME = 3000;

const ChatItemHeader: React.FC<ChatItemHeaderProps> = ({ chat, pinnedChat, isLoggedIn }) => {
  // ThreadChatの場合はバックエンドで加工済みなのでそのまま表示
  // Chat/PinnedChatの場合はdayjsで日時フォーマット
  const displayTime = isThread(chat) ? chat.created_at : dayjs(chat.created_at).format('HH:mm');

  return (
    <div className='flex items-center gap-3'>
      <ChatAvatar
        chat={chat}
        isLoggedIn={isLoggedIn}
      />
      <div className='flex items-center gap-1 truncate'>
        {pinnedChat && pinnedChat.id === chat.id ? (
          <img
            className='size-[20px] flex-[0_0_auto]'
            src={IconPin}
            width='20'
            height='20'
            alt=''
          />
        ) : null}
        <ChatDisplayName
          chat={chat}
          isLoggedIn={isLoggedIn}
        />
      </div>
      <div className='flex gap-[4px]'>
        <span className='text-[10px]'>{displayTime}</span>
      </div>
    </div>
  );
};

export default ChatItemHeader;
